
export const EMAIL_CHANGED = 'email_changed';
export const PASSWORD_CHANGED = 'password_changed';
export const PASSWORD_CONFIRM_CHANGED = 'password_confirm_changed';
export const MESSAGE_CHANGED = 'message_changed';
export const NAME_CHANGED = 'name_changed';

export const REGISTER_USER = 'register_user';
export const REGISTER_USER_SUCCESS = 'register_user_success';
export const REGISTER_USER_FAIL = 'register_user_fail';

export const LOGIN_USER = 'login_user';
export const LOGIN_USER_SUCCESS = 'login_user_success';
export const LOGIN_USER_FAIL = 'login_user_fail';
export const LOGOUT_SUCCESS = 'logout_success'

export const USERS_DATA = 'users_data';
export const MY_DATA = 'my_data';
export const RECENTS_DATA = 'recents_data';

export const MY_GROUPS_DATA = 'my_groups_data';
export const LOAD_GROUP_MESSAGES = 'load_group_messages';
export const GROUP_USERS = 'group_users';
export const GROUP_USERS_SUCCESS = 'group_users_success';
export const GROUP_USER_INFO = 'group_users_info';
export const GROUP_USER_INFO_SUCCESS= 'group_users_info_success';
export const CREATE_GROUP_SUCCESS = 'create_group_success';
export const CREATE_GROUP = 'create_group';

export const SEND_MESSAGE_SUCCESS = 'send_message_success';
export const SEND_MESSAGE = 'send_message';
export const LOAD_MESSAGES = 'load_messages';
export const LOAD_MESSAGES_SUCCESS = 'load_messages_success';

export const SELECT_USER = 'select_user';
export const SELECT_USER_INFO = 'select_user_info';


// WEBPACK FOOTER //
// ./src/actions/types.js